import React from 'react'
import "./ContactUs.css"
import {motion} from "framer-motion";

function ContactUs() {
    return (
        <div className='ContactUs'>
            <motion.h2
                className="AboutDhonustitle"
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                    duration: 1,
                    ease: "easeOut",
                }}
                viewport={{ once: true }}
            >
                Contact Us
            </motion.h2>
            <motion.p
                className="AboutDhonusPara"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                    duration: 1.2,
                    delay: 0.3,
                    ease: "easeOut",
                }}
                style={{ fontSize: "1rem" }}
                viewport={{ once: true }}
            >
                For enquires and consultation , please reach out to us . our team is always there to guide you .
            </motion.p>
 <motion.div
      className="DhannusEmailContainer"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <motion.input
        type="email"
        className="DhannusEmailInput"
        placeholder="Enter your email"
        whileFocus={{ scale: 1.05 }}
        transition={{ duration: 0.3 }}
      />
      <motion.button
        className="DhannusEmailButton"
        whileHover={{ scale: 1.1, boxShadow: "0 0 15px rgba(255, 215, 0, 0.7)" }}
        transition={{ type: "spring", stiffness: 200 }}
      >
        Submit
      </motion.button>
    </motion.div>

        </div>
    )
}

export default ContactUs